<template>
    <div class="panel">
        <div class="row">
            <div class="col1">
                <CircleImage
                    v-for="item in data1"
                    :key="item.title"
                    class="item"
                    :title="item.title"
                    image="https://picsum.photos/seed/farm/150/150"
                    :text="item.state"
                    :is-disabled="item.state === 'No'"
                />
            </div>
            <div class="col2">
                <CircleImage
                    v-for="item in data2"
                    :key="item.title"
                    class="item"
                    :title="item.title"
                    image="https://picsum.photos/seed/industry/150/150"
                    :text="item.state"
                    :is-disabled="item.state === 'No'"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

import CircleImage from '../CircleImage/CircleImage.vue';

export default defineComponent({
    name: 'RemediationSystem',
    components: {
        CircleImage
    },
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const data1 = [
            { title: 'landfarming', state: props.siteDetails?.landFarming },
            { title: 'Soil vapour extraction', state: props.siteDetails?.soilVaporExtraction },

        ];
        const data2 = [
            { title: 'Air sparging', state: props.siteDetails?.airSparging },
            { title: 'Allu bucket', state: props.siteDetails?.alluBucket },
            { title: 'Biopiles', state: props.siteDetails?.bioPiles },
            { title: 'Biosparging', state: props.siteDetails?.bioSparging },
            { title: 'Bioventing', state: props.siteDetails?.bioventing },
            { title: 'Chemical oxidation', state: props.siteDetails?.chemicalOxidation },
            { title: 'Dig and dump', state: props.siteDetails?.digAndDump },
            { title: 'Dual phase extraction', state: props.siteDetails?.dualPhaseExtraction },
            { title: 'Enhanced aerobic bioremediation', state: props.siteDetails?.enhancedAerobicBioRemediation },
            { title: 'In situ groundwater bioremediation', state: props.siteDetails?.inSituGroundwaterBioRemediation },
            { title: 'Low temp thermal desorption', state: props.siteDetails?.lowTempThermalDesorption },
            { title: 'Other', state: props.siteDetails?.other },
        ];

        return {
            data1,
            data2
        };
    }
});
</script>

<style lang="postcss" scoped>
.panel {
    @apply -mt-8;

   .row {
       @apply flex flex-row;

       .col1, .col2 {
           @apply flex flex-wrap content-start;
       }

       .col1 {
           @apply w-1/5;

           .item {
               @apply w-full;
           }
       }

       .col2 {
           @apply w-4/5;

       }
   }

   .item {
       @apply p-4 justify-end flex flex-col w-1/4;
   }
}
</style>
